import { useState } from 'react'

import { Rule, validateFields } from '../utils/validateForm'

import CheckboxField from './CheckBoxField'
import InputTextArea from './InputTextArea'

/*
Botón estandard para acciones
*/
export const ButtonAction: React.FC<{
  label: string
  handleButtonClick: (e: React.MouseEvent<HTMLButtonElement>) => void
  disabled?: boolean
}> = ({ label, handleButtonClick, disabled }) => {
  const className = disabled
    ? 'px-4 py-2 bg-gray-300 text-gray-500 font-bold cursor-not-allowed rounded-lg'
    : 'px-4 py-2 bg-blue-500 text-white font-bold rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500'

  return (
    <button className={className} disabled={disabled} onClick={handleButtonClick} type="button">
      {label}
    </button>
  )
}

/*
Botón estandard para menues
*/
export const ButtonMenu: React.FC<{
  label: string
  index: number
  clickedIndex: number
  handleButtonClick: (e: number) => void
}> = ({ label, index, clickedIndex, handleButtonClick }) => {
  return (
    <button
      onClick={() => handleButtonClick(index)}
      className={` font-bold   px-4 py-2 rounded-xl  focus:outline-none  ${clickedIndex === index ? 'bg-white text-blue-500' : 'hover:bg-blue-400 hover:text-blue bg-blue-500 text-white'}`}
    >
      {label}
    </button>
  )
}
export const ButtonMenuShort: React.FC<{
  label: string
  index: number
  clickedIndex: number
  handleButtonClick: (e: number) => void
}> = ({ label, index, clickedIndex, handleButtonClick }) => {
  return (
    <button
      onClick={() => handleButtonClick(index)}
      className={`px-4 py-1 rounded-xl  focus:outline-none  ${clickedIndex === index ? 'bg-white text-blue-500' : 'hover:bg-blue-400 hover:text-blue bg-blue-500 text-white'}`}
    >
      {label}
    </button>
  )
}
/*
Conjunto de botones horizontal.
Si viene un boton en blanco, se lo salta, pero mantiene el index, para no tenr que
cambiar el código que depende de index
*/
export const ButtonMenuSet: React.FC<{
  captions: string[]
  clickedIndex: number
  handleButtonClick: (e: number) => void
  className?: string
  short?: boolean
}> = ({ captions, clickedIndex, handleButtonClick, className, short }) => {
  const cn = className ?? `flex flex-wrap gap-2 border ${short ? 'p-0.5' : 'p-1'}  rounded-2xl bg-blue-500`

  return (
    <div className={cn}>
      {captions.map(
        (caption, index) =>
          caption !== '' && (
            <div key={`${index}-${caption}`}>
              {short ? (
                <ButtonMenuShort
                  label={caption}
                  index={index}
                  clickedIndex={clickedIndex}
                  handleButtonClick={handleButtonClick}
                />
              ) : (
                <ButtonMenu
                  label={caption}
                  index={index}
                  clickedIndex={clickedIndex}
                  handleButtonClick={handleButtonClick}
                />
              )}
            </div>
          )
      )}
    </div>
  )
}
export const ButtonPrint: React.FC = () => {
  const handleImprimirClick = async () => {
    window.print()
  }

  return (
    <div className="flex flex-col items-center print:hidden">
      <ButtonAction label={'\u{1F5B6} Imprimir'} handleButtonClick={handleImprimirClick} />
    </div>
  )
}
/*
Despliega un boton con el ícono de un tarro de basura.
*/
export const ButtonDelete: React.FC<{
  key: string
  handleButtonClick: (e: string) => void
}> = ({ key, handleButtonClick }) => {
  return (
    <button
      className="border-b pr-4 cursor-pointer hover:text-red-500 focus:outline-none focus:ring-2"
      onClick={(event) => {
        // El siguiente e necesario para que este evento (clik) no sea atrapado por (por ejemplo)
        // un handler del click en la fila
        event.stopPropagation() // Stop the event from bubbling to the row
        handleButtonClick(key) // Call the parent function with the key
      }}
      aria-label="Delete"
    >
      🗑️
    </button>
  )
}

/*
Botón estandard para acciones, un pooco mas bajo
*/
export const ButtonActionShort: React.FC<{
  label: string
  handleButtonClick: (e: React.MouseEvent<HTMLButtonElement>) => void
  disabled?: boolean
}> = ({ label, handleButtonClick, disabled }) => {
  const className = disabled
    ? 'px-4 py-1 bg-gray-300 text-gray-500 cursor-not-allowed rounded-lg'
    : 'px-4 py-1 bg-blue-500 text-white  rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500'

  return (
    <button className={className} disabled={disabled} onClick={handleButtonClick} type="button">
      {label}
    </button>
  )
}

export const ButtonAddIcon: React.FC<{
  handleButtonClick: (e: React.MouseEvent<HTMLButtonElement>) => void
}> = ({ handleButtonClick }) => {
  return (
    <button className="flex bg-blue-500 rounded-full  hover:bg-blue-600 focus:outline-none" onClick={handleButtonClick}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" className="w-6 h-6">
        <rect x="4" y="11" width="16" height="2" />

        <rect x="11" y="4" width="2" height="16" />
      </svg>
    </button>
  )
}
export const ButtonCheckConfirma: React.FC<{
  title: string
  subTitle: string
  checkLabel: string
  buttonLabel: string
  handleCrearClick: (e: React.MouseEvent<HTMLButtonElement>) => void
  handleTextAreaChange?: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void
  textAreaLabel?: string
  textAreaName?: string
  textAreaValue?: string
  disabled?: boolean
}> = ({
  title,
  subTitle,
  checkLabel,
  buttonLabel,
  handleCrearClick,
  handleTextAreaChange,
  textAreaLabel,
  textAreaName,
  textAreaValue,
  disabled = false,
}) => {
  const [check, setCheck] = useState<boolean>(false)
  const [errors, setErrors] = useState<{ [key: string]: string }>({})

  // Handle checkbox change
  const handleCheckChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = e.target
    setCheck(checked)
  }

  const handleCrearClickInt = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!check) return

    if (handleTextAreaChange && textAreaName && textAreaValue?.length == 0) {
      // Colocamos en rojo
      const fields = [{ name: textAreaName, value: textAreaValue, rule: Rule.REQUIRED }]

      const validationErrors = validateFields(fields)

      if (Object.keys(validationErrors).length > 0) {
        setErrors(validationErrors) // Set errors if any

        return
      }

      setErrors({})
    }
    handleCrearClick(e)
  }

  return (
    <>
      <div className="mb-2 mt-4">
        <span className="font-bold text-xl">{title}</span>
      </div>
      <div>{subTitle}</div>
      {handleTextAreaChange && (
        <div className="mb-2">
          <InputTextArea
            label={textAreaLabel ?? ''}
            name={textAreaName ?? ''}
            value={textAreaValue}
            handleInputChange={handleTextAreaChange}
            errors={errors}
          />
        </div>
      )}

      <div className="border border-gray-300 p-4 rounded-md shadow-sm">
        <CheckboxField
          name="aceptar"
          value=""
          label={checkLabel}
          checked={check}
          handleInputChange={handleCheckChange}
        />
      </div>
      <div className="flex justify-center mt-1">
        <ButtonAction
          label={buttonLabel}
          handleButtonClick={handleCrearClickInt}
          disabled={!check || (handleTextAreaChange && (textAreaValue ?? '').length === 0) || disabled} // Disable the button when not checked, textArea is empty, or disabled prop is true
        />
      </div>
    </>
  )
}
// Para poder pasarle el estado del "check" y resetearlo desde afuera
export const ButtonCheckConfirmaEx: React.FC<{
  title: string
  subTitle: string
  checkLabel: string
  buttonLabel: string
  handleCrearClick: (e: React.MouseEvent<HTMLButtonElement>) => void
  handleTextAreaChange?: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void
  textAreaLabel?: string
  textAreaName?: string
  textAreaValue?: string
  check: boolean
  setCheck: React.Dispatch<React.SetStateAction<boolean>>
}> = ({
  title,
  subTitle,
  checkLabel,
  buttonLabel,
  handleCrearClick,
  handleTextAreaChange,
  textAreaLabel,
  textAreaName,
  textAreaValue,
  check,
  setCheck,
}) => {
  const [errors, setErrors] = useState<{ [key: string]: string }>({})

  // Handle checkbox change
  const handleCheckChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = e.target
    setCheck(checked)
  }

  const handleCrearClickInt = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!check) return

    if (handleTextAreaChange && textAreaName && textAreaValue?.length == 0) {
      // Colocamos en rojo
      const fields = [{ name: textAreaName, value: textAreaValue, rule: Rule.REQUIRED }]

      const validationErrors = validateFields(fields)

      if (Object.keys(validationErrors).length > 0) {
        setErrors(validationErrors) // Set errors if any

        return
      }

      setErrors({})
    }
    handleCrearClick(e)
  }

  return (
    <>
      <div className="mb-2 mt-4">
        <span className="font-bold text-xl">{title}</span>
      </div>
      <div>{subTitle}</div>
      {handleTextAreaChange && (
        <div className="mb-2">
          <InputTextArea
            label={textAreaLabel ?? ''}
            name={textAreaName ?? ''}
            value={textAreaValue}
            handleInputChange={handleTextAreaChange}
            errors={errors}
          />
        </div>
      )}

      <div className="border border-gray-300 p-4 rounded-md shadow-sm">
        <CheckboxField
          name="aceptar"
          value=""
          label={checkLabel}
          checked={check}
          handleInputChange={handleCheckChange}
        />
      </div>
      <div className="flex justify-center mt-1">
        <ButtonAction
          label={buttonLabel}
          handleButtonClick={handleCrearClickInt}
          disabled={!check} // Disable the button when not checked
        />
      </div>
    </>
  )
}
